import html2canvas from 'html2canvas';

export async function telechargerImage(element, nom = 'carte-vivante') {
  if (!element) return;
  const canvas = await html2canvas(element, { backgroundColor: '#0b1220', scale: 2, useCORS: true, logging: false });
  const a = document.createElement('a');
  a.href = canvas.toDataURL('image/png');
  a.download = `${nom}-${new Date().toISOString().slice(0, 10)}.png`;
  a.click();
}
